import { NgModule } from '@angular/core';
import { SharedModule } from 'app/components/shared.module';
import { SectionModule } from 'app/views/presentations/layouts/layouts/section.module';
import { TwoSectionsVerticalLayout, TwoSectionsVerticalLayoutComponent } from 'app/views/presentations/layouts/layouts/twoSectionsVerticalLayout/twoSectionsVerticalLayout.component';
import { LayoutWrapperModule } from 'app/views/presentations/layouts/layoutWrapper.module';

@NgModule({
    imports: [
        SharedModule,
        SectionModule,
        LayoutWrapperModule.wrapLayout(TwoSectionsVerticalLayout)
    ],
    declarations: [
        TwoSectionsVerticalLayoutComponent
    ],
    entryComponents: [
        TwoSectionsVerticalLayoutComponent
    ]
})
export class TwoSectionsVerticalLayoutModule { }


// WEBPACK FOOTER //
// ./src/app/views/presentations/layouts/layouts/twoSectionsVerticalLayout/twoSectionsVerticalLayout.module.ts